import { useParams } from '@tanstack/react-router';
import { useSnapshot } from 'valtio';
import projectDetailsStore from '../store';
import CGSRegulatoryMaps from './CGSRegulatoryMaps';
import HistoricalUSGSMaps from './HistoricalUSGSMaps';
import LayerSection from './LayerSection';
import Studies from './Studies';

export function MapChildren() {
  return null;
}

export function TabDetails() {
  const { projectId } = useParams({ strict: false }) as { projectId: string };
  const { isProjectInCalifornia } = useSnapshot(projectDetailsStore);

  return (
    <div className="flex flex-auto flex-col space-y-4 pb-24">
      {isProjectInCalifornia && <CGSRegulatoryMaps projectId={projectId} />}
      <HistoricalUSGSMaps projectId={projectId} />
      {isProjectInCalifornia && <Studies />}

      {isProjectInCalifornia && <LayerSection title={'Soils'} layerId="soils" fields={['Taxonomic_Orders']} />}
      <LayerSection
        title={'Flood Hazard Zones'}
        layerId="geotechnicalFloodHazardZones"
        fields={['FLD_AR_ID', 'FLD_ZN_SUB', 'FLD_CHANCE']}
      />
      {isProjectInCalifornia && (
        <LayerSection
          title={'Groundwater Stations'}
          layerId="geotechnicalGroundwaterStations"
          fields={['WELLNAME', 'SOURCE', 'LOCDESC', 'DEPTH', 'LAST_MSMT_', 'GSE']}
        />
      )}
      {isProjectInCalifornia && (
        <LayerSection
          title={'Groundwater Elevations'}
          layerId="geotechnicalGroundwaterElevations"
          fields={['DT1STWTR', 'ACRES']}
        />
      )}
      <LayerSection
        title={'Landslide Areas'}
        layerId="geotechnicalLandslideAreas"
        fields={['QUAD_NAME', 'GEOPDFLINK', 'REPORTLINK']}
      />
      {isProjectInCalifornia && (
        <LayerSection
          title={'Liquefaction Zone'}
          layerId="geotechnicalLiquefactionZones"
          fields={['QUAD_NAME', 'GEOPDFLINK', 'REPORTLINK']}
        />
      )}
      {isProjectInCalifornia && (
        <LayerSection title={'Tsunami Inundation Areas'} layerId="otherTsunamiInundationAreas" fields={['Inundated']} />
      )}
      <LayerSection
        title={'Wells'}
        layerId="geotechnicalOilGasWells"
        fields={['WellStatus', 'WellNumber', 'API', 'LeaseName', 'WellTypeLa', 'OperatorNa']}
      />
      {isProjectInCalifornia && (
        <LayerSection
          title={'Fault Hazard'}
          layerId="geotechnicalAlquistPrioloFaultHazardZones"
          fields={['QUAD_NAME', 'GEOPDFLINK', 'REPORTLINK']}
        />
      )}
    </div>
  );
}
